import $ from 'jquery'
import Cookies from 'js-cookie'

/**
 * View
 */
export default class AuthView {
  /**
   * @param {auth} model
   * @param {authController} controller
   */
  constructor(model, controller) {
    this.model = model
    this.controller = controller

    /**
     * observerにviewのrenderを追加
     * modelのstateが変更される度にrenderされる
     */
    model.add(this.render.bind(this))

    this.bindEvents()
        .checkCookie()
  }

  /**
   * modelのactionに応じてrender
   * @param {String} type
   */
  render(type) {
    switch (type) {
      case 'setUserAge':
        // userDrinkingAgeがtrueの時(先にCountryを選択した場合)
        if (this.model.state.userDrinkingAge){
          this.verify()
              .bindEventsAfterFulfilled()
              .enableSubmit()
        }
        break

      case 'birthYearSelected':
      case 'birthMonthSelected':
      case 'birthDaySelected':
        this.checkDateVal()
        break

      case 'countrySelected':
        this.checkDrinkingAge(this.model.state.userCountry)
        break

      case 'setUserDrinkingAge':
        // userAgeがtrueの時(先に誕生日選択した場合)
        if (this.model.state.userAge){
          this.verify()
              .bindEventsAfterFulfilled()
              .enableSubmit()
        }
        break

      case 'submitAuth':
        // showContentsがtrueならajaxCall
        if (this.model.state.showContents){
          this.ajaxCall(location.pathname, this.dynamicAppendScriptTags)
              .setCookie()
        } else {
          this.showAnnotation()
        }
        break
    }
  }

  checkCookie() {
    /**
     * Cookieをチェックして
     * visitorが取れなかったらshowAuth
     */
    if (!Cookies.get('visitor')){
      this.controller['showAuth']()
    }

    return this
  }

  appendAuthView() {
    if (this.model.state.showAuthView)
      this.ajaxCall('/co/en/data/auth.html')

    return this
  }

  bindEvents() {
    document.addEventListener('DOMContentLoaded', () => {
      this.wrapper = document.getElementById('root')

      this.appendAuthView()
          .bindMutationEvents()
    })

    return this
  }

  bindMutationEvents() {
    /**
     * DOM要素の追加を監視
     */
    if (typeof MutationObserver !== 'undefined') {
      const mutationObserver = new MutationObserver( mutations => {
        mutations.forEach( mutation => {
          this.setElems()
          // setElemsが済んだら監視を中止
          mutationObserver.disconnect()
        })
      })

      mutationObserver.observe(this.wrapper, {childList: true})
    } else {
      document.addEventListener('DOMNodeInserted', () => {
        this.setElems()
        // setElemsが済んだら監視を中止
        document.removeEventListener('DOMNodeInserted')
      })
    }
  }

  setElems() {
    this.selectY = window.document.getElementById('YY')
    this.selectM = window.document.getElementById('MM')
    this.selectD = window.document.getElementById('DD')
    this.selectCountry = window.document.getElementById('country')
    this.checkbox = window.document.getElementById('checkbox')
    this.submit = window.document.getElementById('submit')
    this.bindFormEvents()
  }

  bindFormEvents() {
    this.selectY.addEventListener('change', e => {
      this.controller['input']('YY', $(e.target).val())
    })

    this.selectM.addEventListener('change', e => {
      this.controller['input']('MM', $(e.target).val())
    })

    this.selectD.addEventListener('change', e => {
      this.controller['input']('DD', $(e.target).val())
    })

    this.selectCountry.addEventListener('change', e => {
      this.controller['input']('Country', $(e.target).val())
    })

    this.checkbox.addEventListener('change', e => {
      this.controller['input']('Remember', e.target.checked)
    })
  }

  bindEventsAfterFulfilled() {
    // removeしてからaddする
    this.unbindEvents(this.submit, 'click', this.controller['submit'])
    this.submit.addEventListener('click', this.controller['submit'])

    return this
  }

  /**
   * リスナー削除
   * @param {DOM} tar
   * @param {event} e
   * @param {function} func
   */
  unbindEvents(tar, e, func) {
    tar.removeEventListener(e, func)
  }

  checkDateVal() {
    if (this.model.state.userBirthYear > 0 && this.model.state.userBirthMonth > 0 && this.model.state.userBirthDay > 0){
      this.controller['setAge'](null, this.calcAge())
    } else if (this.model.state.userBirthYear < 0 || this.model.state.userBirthMonth < 0 || this.model.state.userBirthDay < 0) {
      this.disableSubmit()
    }
  }

  /**
   * @return {Array} [YYYY, MM, DD]を返す
   */
  dateAry() {
    return [this.model.state.userBirthYear, this.model.state.userBirthMonth, this.model.state.userBirthDay]
  }

  /**
   * @return {Number} userAgeを返す
   */
  calcAge() {
    /**
     * @type {Array}
     */
    const bday = this.dateAry()
    /**
     * @type {Date} Dateオブジェクト
     */
    const today = new Date()

    if (parseInt(bday[1], 10) * 100 + parseInt(bday[2], 10) > (today.getMonth() + 1) * 100 + today.getDate()) {
      return today.getFullYear() - parseInt(bday[0], 10) - 1
    } else {
      return today.getFullYear() - parseInt(bday[0], 10)
    }
  }

  /**
   * Cookie付与
   * rememberの有無でexpire dateを設定
   */
  setCookie() {
    /**
     * @type {Date} 日付指定したDateオブジェクト
     */
    const date = new Date(2038, 0, 18)
    /**
     * @type {Number} rememberAgeがtrueならdate、falseなら1
     */
    const expireDate = this.model.state.rememberAge ? date : 1
    Cookies.set('visitor', 1, {expires: expireDate})
    return this
  }

  /**
   * データ取得先を指定
   * @param {String} path
   */
  ajaxCall(path, callback) {
    $.ajax({
      url: path,
      dataType: 'html',
      type: 'get',
      cache: false,
      xhrFields: {
        withCredentials: true
      },
    }).done(data => {
      const html = $(data).filter('#root')[0].innerHTML

      this.wrapper.innerHTML = html
    }).fail(err => {
      throw err
    }).always(callback)

    return this
  }

  /**
   * @param {String} userCountry
   * @return {Number} 飲酒可能年齢を返す
   */
  returnDrinkingAge(userCountry) {
    /**
     * @type {Obj} 国名と飲酒可能年齢の連想配列
     */
    const countryList = {
      'Australia': 18,
      'Brazil': 18,
      'China': -1,
      'China (Hong Kong)': 18,
      'France': 18,
      'Japan': 20,
      'Korea': 19,
      'Singapore': 18,
      'Taiwan (China)': 18,
      'United Kingdom': 18,
      'United States': 21,
      'Others': -1
    }

    return countryList[userCountry]
  }

  /**
   * @param {String} userCountry
   */
  checkDrinkingAge(userCountry) {
    // 初期値(未選択)の場合は''
    if (userCountry !== '') {
      this.controller['setDrinkingAge'](null, this.returnDrinkingAge(userCountry))
    } else {
      this.disableSubmit()
    }
  }

  /**
   * userDrinkingAgeとuserAgeを比較してpermissionを変更する
   */
  verify() {
    if (this.model.state.userAge >= this.model.state.userDrinkingAge) {
      this.controller['verify'](null, true)
    } else {
      this.controller['verify'](null, false)
    }

    return this
  }

  disableSubmit() {
    this.unbindEvents(this.submit, 'click', this.controller['submit'])
    $(this.submit).addClass('is-disable')
  }

  enableSubmit() {
    $(this.submit).removeClass('is-disable')
  }

  showAnnotation() {
    // 既にannotationがvisibleだったら追加しない
    if (!this.model.state.annotationVisible) {
      this.wrapper.innerHTML += '<p class="p-auth-annotation">Sorry, you must be above the legal drinking age to enter this site.</p>' 

      // innerHTMLで書き換えるとeventが失われるので再度バインド
      this.setElems()
    }

    this.clearInputData()

    this.controller['setAnnotationVisibility']()
  }

  clearInputData() {
    this.controller['clearInputData']()

    this.selectY.selectedIndex = 0
    this.selectM.selectedIndex = 0
    this.selectD.selectedIndex = 0
    this.selectCountry.selectedIndex = 0
    this.checkbox.checked = false

    // submitボタンをdisableに戻す
    this.disableSubmit()
  }

  /**
   * scriptタグを動的に追加してlib.js, app.jsを再度実行する
   */
  dynamicAppendScriptTags() {
    // 無効なscriptタグを削除
    const elems = document.body.getElementsByTagName('script')
    for (let i = elems.length - 1; i >= 0; i--) {
      document.body.removeChild(elems[i])
    }

    const scripts = ['/co/assets/js/lib.js', '/co/assets/js/app.js']
    const len = scripts.length
    let i = 0;

    // lib.js => app.jsの順に追加
    (function append() {
      const script = document.createElement('script')
      script.src = scripts[i]
      document.body.appendChild(script)

      if (i++ < len - 1) {
        script.onload = append
      }
    })()
  }
}



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/auth/views/authView.js
 **/